const hideAllWidth = 768 // define the point at which all menu items are hidden
let resizeTimer
let currentsize = window.innerWidth

/**
 * converts a css value string with "px" at the end to an int
 */
function getIntFromPxString (str) {
  return parseInt(str.replace('px', ''));
}

/**
 * Detects edge colision of vlistItem with the window edge
 */
function detectEdgeCollision( vlistItem, button ) { 
  const nav      = document.querySelector('.main-nav')
  const navStyle = window.getComputedStyle( document.querySelector('.main-nav') )
  const gap      = getIntFromPxString(navStyle.columnGap)
  const navEdge  = parseInt(nav.getBoundingClientRect().right)
  const liEdge   = parseInt(vlistItem.getBoundingClientRect().right)
  const btnShow  = ( ! button.classList.contains('hide') ) ? true : false
  const offset   = ( btnShow ) ? navEdge - button.offsetWidth - gap : navEdge

  return (liEdge > offset)
}

/**
 * Moves menu items between visible/hidden nav lists based on overflow posistion
 */
function updateNavItems(e) {

  // this is needed to prevent the code running until risizing has finished
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout( () => {

    let direction = (window.innerWidth > currentsize) ? 'wide' : 'narrow'
    let vlist     = document.querySelector('.main-nav__list')
    let hlist     = document.querySelector('.main-nav__hiddenList')
    let button    = document.querySelector('.main-nav__more')

    let movers = [] // list of elements to pop over

    // now we have a direction, set currentsize for next time
    currentsize = window.innerWidth

    // if resize made the page narrower
    if ( direction === 'narrow' ) {

      // loop through vlist children
      let i = vlist.children.length
      for(i; i != 0; i--) {

        // get the last item in the list
        let vlistItem = vlist.lastElementChild

        // move to hlist if it collides with window or mobile breakpoint is triggered
        let collided = detectEdgeCollision( vlistItem, button )
        if ( collided || window.innerWidth < hideAllWidth ) {
          console.log('collision detecteed')
          if(hlist.children.length > 0) {
            hlist.insertBefore( vlistItem, hlist.children.item(0) );
          } else {
            hlist.append( vlistItem )
          }
        }

      }

    }

    // otherwise, the resize made the page wider…
    else if(window.innerWidth > hideAllWidth) {

      // loop through hidden nav…
      while ( true && hlist.children.length > 0 ) {

        // get the "first" item, and clone it
        let item = hlist.children.item(0).cloneNode(true)

        // append cloned item to visible nav
        vlist.append(item)

        // if it doesn't overflow the nav (it fits), remove item from hidden list
        let vlistItem = vlist.lastElementChild
        let collision = detectEdgeCollision( vlistItem, button )
        if( ! collision ) {
          hlist.children.item(0).remove()
        }

        // otherwise, it does overflow the nav and we should remove item from vlist and break the loop
        else {
          vlist.lastElementChild.remove()
          break
       }
      }

    }

    // show or hide the "more" button depending on hlist length
    if(hlist.children.length === 0) {
      button.classList.add('hide')
    } else {
      button.classList.remove('hide')
    }
  }, 100);

}
window.addEventListener('load', updateNavItems)
window.addEventListener('resize', updateNavItems)


/**
 * Toggles the hidden list of nav items
 */
function toggleMoreNav(){
  let hlist   = document.querySelector('.main-nav__hiddenList')
  hlist.classList.toggle('show')
}
window.addEventListener('load', () => {
  document.querySelector('.main-nav__more').addEventListener('click', toggleMoreNav)
})